import { useQuery } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { formsApi } from '../api/formsApi';

export function useFormQueue(enabled = true) {
  return useQuery({
    queryKey: keys.forms.queue,
    queryFn: ({ signal }) => formsApi.getQueue({ signal }),
    staleTime: 30_000,
    refetchInterval: enabled ? 30_000 : false,
    enabled,
  });
}
